<template>
<div id="create-purchasable-item">
  <h2>Create Purchasable Item</h2>

  <purchasable-item-form
  ></purchasable-item-form>
</div>
</template>

<script>
import PurchasableItemForm from '@/components/PurchasableItemForm'

import PurchasableItemNav from '@/components/PurchasableItemNav'

import PurchasableItemStore from '@/stores/PurchasableItemStore'

export default {
  data () {
    return PurchasableItemStore.state
  },

  props: ['purchasableItemId'],

  components: {
    'purchasable-item-form': PurchasableItemForm,
    'purchasable-item-nav': PurchasableItemNav
  },

  created () {
    this.apiGet('/new/purchasable_item', PurchasableItemStore, true)
  },

  methods: {
    get () {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PurchasableItemCreate.vue